import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';

var SortArrow = function SortArrow(_ref) {
  var status = _ref.status;
  return /*#__PURE__*/React.createElement("span", {
    className: "column-sorter"
  }, /*#__PURE__*/React.createElement("i", {
    className: "roo-icon roo-icon-arrow-up ".concat(status === 'asc' ? 'on' : 'off')
  }), /*#__PURE__*/React.createElement("i", {
    className: "roo-icon roo-icon-arrow-down ".concat(status === 'desc' ? 'on' : 'off')
  }));
};

var TableTh = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableTh, _React$PureComponent);

  var _super = _createSuper(TableTh);

  function TableTh() {
    var _this;

    _classCallCheck(this, TableTh);

    _this = _super.apply(this, arguments);

    _this.handleClick = function () {
      var _this$props = _this.props,
          onSort = _this$props.onSort,
          data = _this$props.data;
      var prop = data.prop,
          sortable = data.sortable;
      if (!sortable) return;
      onSort({
        prop: prop,
        order: _this.sortStatus === 'asc' ? 'desc' : 'asc'
      });
    };

    return _this;
  }

  _createClass(TableTh, [{
    key: "renderContent",
    value: function renderContent() {
      var data = this.props.data;
      var renderTh = data.renderTh,
          label = data.label;
      if (renderTh) return /*#__PURE__*/React.createElement("span", null, renderTh(data));
      return /*#__PURE__*/React.createElement("span", null, label);
    }
  }, {
    key: "render",
    value: function render() {
      var sortable = this.props.data.sortable;
      var _this$props2 = this.props,
          colSpan = _this$props2.colSpan,
          rowSpan = _this$props2.rowSpan;
      return /*#__PURE__*/React.createElement("th", {
        className: sortable ? 'cursor-pointer' : '',
        onClick: this.handleClick,
        style: this.alignStyle,
        colSpan: colSpan,
        rowSpan: rowSpan
      }, this.renderContent(), sortable && /*#__PURE__*/React.createElement(SortArrow, {
        status: this.sortStatus
      }));
    }
  }, {
    key: "sortStatus",
    get: function get() {
      var _this$props3 = this.props,
          sort = _this$props3.sort,
          data = _this$props3.data;
      if (data.prop !== sort.prop) return 'none';
      return sort.order;
    }
  }, {
    key: "alignStyle",
    get: function get() {
      var _this$props$data = this.props.data,
          _this$props$data$alig = _this$props$data.align,
          align = _this$props$data$alig === void 0 ? 'left' : _this$props$data$alig,
          headAlign = _this$props$data.headAlign;
      var style = {};
      style.textAlign = headAlign || align;
      return style;
    }
  }]);

  return TableTh;
}(React.PureComponent);

export { TableTh as default };